import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { CustomButton } from '../button/CustomButton';

const CustomColumn = styled.div`
  width: calc(40% - 1rem);
  padding: 0 1rem;
  display: flex;
  button {
    width: 100%;
  }
  @media screen and (max-width: 640px) {
    width: 100%;
    padding: 0;
    margin-bottom: 6px;
  }
`;

const StyledButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 -1rem 2rem -1rem;
  flex-grow: 1;
  width: calc(100% + 2rem);
  > div:last-of-type {
    justify-self: flex-end;
    margin-left: auto;
  }
  @media screen and (max-width: 640px) {
    flex-direction: column;
    width: 100%;
    margin: 0;
  }
`;

export const ButtonRow = ({ nextTitle, prevTitle, canGoNext, nextAction, nextTestId }: any) => {
  const history = useHistory();

  return (
    <StyledButtonRow>
      <CustomColumn>
        <CustomButton
          priority="secondary"
          onClick={() => history.goBack()}
          fullWidth
          data-testid="backButton"
        >
          {prevTitle}
        </CustomButton>
      </CustomColumn>
      <CustomColumn>
        <CustomButton onClick={nextAction} disabled={!canGoNext} fullWidth data-testid={nextTestId}>
          {nextTitle}
        </CustomButton>
      </CustomColumn>
    </StyledButtonRow>
  );
};
